module.exports = __webpack_public_path__ + "static/ngde-3b8b0a79a794b8bbdc41cd52cc6c6204.png";